import React from "react";
// Routing
import { Link } from "react-router-dom";

// Styling
import styled from "styled-components";

import { motion } from "framer-motion";
import not_logged from "../images/seedimages/1.png";
import portals from "../images/seedimages/2.png";
import seeds from "../images/seedimages/3.png";
import logged from "../images/seedimages/4.png";
import crawls from "../images/seedimages/5.png";
// import godfather from "../images/godfather.jpg";
import sonny from "../images/gf.jpg";
import crawlExplanation from "../images/crawlExplanation.png";

// Animations, Scroll and Icons
import { pageAnimation, Fade, imageAnimation, FadeLine } from "./Animation";
import { ScrollToTop } from "./ScrollToTop";
import { IoCaretBackCircleOutline } from "react-icons/io5";
import { IconContext } from "react-icons";

const ProjectInfoSeed = () => {
  return (
    <ProjectContainer variants={pageAnimation} initial="hidden" animate="show">
      <IconContext.Provider
        value={{
          color: "white",
          size: "70px",
          style: { marginLeft: "3rem" },
        }}
      >
        <Link to="/">
          <Logo>
            <motion.h2 variants={Fade}>Chirag Rao</motion.h2>
            <motion.div variants={Fade}>
              <IoCaretBackCircleOutline className="back" />
            </motion.div>
          </Logo>
        </Link>
      </IconContext.Provider>
      <div className="header">
        <motion.h1 variants={FadeLine}>Se.ed</motion.h1>
        <motion.h3 variants={Fade}>Redefining Literature</motion.h3>
        <Hide>
          <motion.img
            variants={imageAnimation}
            src={not_logged}
            style={{ margin: "1rem 0rem" }}
            alt="seedimage"
          />
        </Hide>
        <Hide>
          <motion.img
            variants={imageAnimation}
            src={logged}
            style={{
              margin: "1rem 0rem",
            }}
            alt="seedimage"
          />
        </Hide>
      </div>
      <div className="content">
        <div className="top">
          <div className="text">
            <motion.h1 variants={FadeLine}>Introduction</motion.h1>
            <motion.p variants={Fade}>
              Get ready for the social phenomenon that will unite people towards
              a new way of reading literature. At times, when we are reading a
              book, we don’t always get multiple perspectives. We have to read a
              lot of different sources to figure out what other people are
              thinking. Our platform will provide opinions and infinite sources.
              <b>Welcome to our Open Source Literature platform.</b>
            </motion.p>
          </div>
          <div className="imageflex">
            <Hide>
              <motion.img variants={imageAnimation} src={crawls} alt="" />
            </Hide>
            <div className="textinner">
              <motion.h3 variants={Fade}>How We Work</motion.h3>
              <motion.p variants={Fade}>
                <b style={{ color: "#23d997" }}>1. </b> Authors and verified
                personnel publish their copyright-allowed text and incomplete
                articles online.
                <br />
                <b style={{ color: "#23d997" }}>2. </b> An article/book which we
                call the seed, has multiple paragraphs and can be read as a
                book.
                <br />
                <b style={{ color: "#23d997" }}>3. </b> Those articles can be
                completed or edited by crawlers, who are people who have
                accessed our platform and want to make changes to the copy
                original text.
                <br />
                <b style={{ color: "#23d997" }}>4. </b> Crawls created by
                crawlers can be read as modals.
              </motion.p>
            </div>
          </div>
        </div>
        <div className="imageflex1">
          <Hide>
            <motion.img variants={imageAnimation} src={sonny} alt="sonny" />
          </Hide>
          <div className="textinner">
            <motion.h3 variants={Fade}>An Example?</motion.h3>
            <motion.p variants={Fade}>
              For example, in the book the Godfather, Sonny( a character ) dies.
              If there is someone who is not satisfied with this part of the
              story, and wants to do something else, e.g. keep him alive, and
              then continue the story in some other way, he/she can make a new
              crawl and manipulating the story according to their liking. People
              can read these crawls and can upvote the crawl if they like it. If
              someone likes part of the crawl, but not the whole, they can
              create a sub-crawl in which they edit it again, and the chain
              continues.
            </motion.p>
          </div>
        </div>
        <div className="imageflex">
          <Hide>
            <motion.img variants={imageAnimation} src={portals} alt="portals" />
          </Hide>

          <div className="textinner">
            <motion.h3 variants={Fade}>Our Portals</motion.h3>
            <motion.p variants={Fade}>
              We are planning to have 3 portals. One for{" "}
              <b style={{ color: "#23d997" }}>Companies</b>, one for{" "}
              <b style={{ color: "#23d997" }}>Educational Institutions</b> and
              one for <b style={{ color: "#23d997" }}> The People</b>.
            </motion.p>
          </div>
        </div>
        <Message>
          <motion.small variants={Fade}>
            All projects are currently under development by our team, hence the
            links have been greyed out.
          </motion.small>
        </Message>
        <ButtonWrapper>
          <motion.button
            variants={Fade}
            style={{ backgroundColor: "#525252", cursor: "default" }}
          >
            View the Website
          </motion.button>
          <motion.button
            variants={Fade}
            style={{ backgroundColor: "#525252", cursor: "default" }}
          >
            View the PPT
          </motion.button>
        </ButtonWrapper>
        <div className="gallery">
          <motion.h1 variants={FadeLine}>Gallery</motion.h1>
          <Hide>
            <motion.img variants={imageAnimation} src={seeds} alt="" />
          </Hide>
          <Hide>
            <motion.img variants={imageAnimation} src={crawls} alt="" />
          </Hide>
          <Hide>
            <motion.img
              variants={imageAnimation}
              src={crawlExplanation}
              alt=""
            />
          </Hide>
        </div>
      </div>
      <ScrollToTop />
    </ProjectContainer>
  );
};

const Logo = styled(motion.div)`
  position: absolute;
  top: 10px;
  left: 10px;
  font-family: "Lobster";
  font-size: "1rem";
  float: right;
  display: flex;
  align-items: flex-end;
  padding: 0rem 1rem;
  margin: 2rem 0rem;
  .back {
    display: none;
  }
  @media screen and (max-width: 520px) {
    h2 {
      display: none;
    }
    .back {
      display: block;
    }
  }
`;

export const Message = styled(motion.div)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-bottom: 7rem;
`;

const ProjectContainer = styled(motion.div)`
  max-width: 3000px;
  .header {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    flex-wrap: wrap;
    img {
      width: 100%;
      height: 30rem;
      object-fit: contain;
    }
  }
  .content {
    padding: 10px;
    .text {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 1rem 0rem;
      margin: 1rem 0rem 0rem 4rem;
      width: 90%;
    }
    p {
      margin: auto;
    }
  }

  font-family: "Quicksand", sans-serif;
  .gallery {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    h1 {
      width: 70%;
    }
    img {
      width: 1000px;
      margin: 1rem 0rem;
      padding: 1rem 0rem;
    }
    @media screen and (max-width: 520px) {
      img {
        width: 100%;
        height: 65vh;
        margin: 1rem 0rem;
        padding: 1rem 0rem;
      }
    }
  }
  .imageflex {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-wrap: wrap;
    flex-direction: row;
    img {
      width: 700px;
      height: 700px;
      object-fit: contain;
      margin: 2rem 0rem 0rem 1rem;
    }
    .textinner {
      max-width: 800px;
    }
  }
  .imageflex1 {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-wrap: wrap;
    flex-direction: row-reverse;
    img {
      width: 700px;
      height: 700px;
      object-fit: contain;

      margin: 2rem 0rem 0rem 1rem;
    }
    .textinner {
      max-width: 800px;
    }
  }

  h1 {
    color: white;
    font-weight: bolder;
    font-size: 3rem;
    padding: 1rem 0rem 2rem 0rem;
    text-align: center;
    font-size: 5rem;
    color: #23d997;
    border-bottom: 2px solid #23d997;
  }
  h3 {
    color: white;
    font-size: 2rem;
    font-weight: bolder;
    padding: 3rem 0rem 2rem 0rem;
    text-align: center;
  }
  p {
    margin: 4rem 0rem;
    color: white;
    font-size: 1.7rem;
    padding: 2rem 4rem;
    max-width: 1000px;
  }

  @media screen and (max-width: 520px) {
    img {
      width: 80%;
      height: 80vh;
      margin: 1rem 0rem;
      padding: 1rem 0rem;
    }
    p {
      font-size: 2rem;
    }
    h1 {
      font-size: 4rem;
    }
    h3 {
      font-size: 3.2rem;
    }
  }
`;

const Hide = styled.div`
  overflow: hidden;
`;

export default ProjectInfoSeed;
